import { render, staticRenderFns } from "./DebateOrPanelAdjudicators.vue?vue&type=template&id=9d46c550&"
import script from "./DebateOrPanelAdjudicators.vue?vue&type=script&lang=js&"
export * from "./DebateOrPanelAdjudicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports